import React from 'react';
import { BugIcon, Button, Tooltip } from '@billda/design-system';
import { useDebugStore } from '../../stores/debugStore';

interface DebugButtonProps {
  size?: 'small' | 'medium' | 'large';
}

export const DebugButton: React.FC<DebugButtonProps> = ({ size = 'small' }) => {
  const { toggleDebug } = useDebugStore();

  const buttonSize =
    size === 'small' ? 'size-8' : size === 'medium' ? 'size-10' : 'size-12';
  const iconSize = size === 'small' ? 16 : size === 'medium' ? 20 : 24;

  return (
    <Tooltip content="Open Debug Panel">
      <Button
        variant="ghost"
        size="icon"
        data-testid="debug-panel-button"
        onClick={toggleDebug}
        className={`${buttonSize} text-content-secondary transition-colors hover:bg-surface-raised hover:text-content-accent`}
        aria-label="Open debug panel"
      >
        <BugIcon size={iconSize} aria-hidden="true" />
      </Button>
    </Tooltip>
  );
};
